// extracted by mini-css-extract-plugin
export default {"notification-badge":"rGk0Wxb","notification-badge--has-value":"BLOs_Ku"};